import { createApi, retry } from '@reduxjs/toolkit/query/react';
import { gemFetchQuery } from './helpers/gemFetchQuery';
import { HYDRATE } from 'next-redux-wrapper';

export const gemApi = createApi({
  reducerPath: 'gemApi',
  tagTypes: [
    'Campaign',
    'Campaigns',
    'TopContentItem',
    'ContentItem',
    'ContentItems',
    'ContentItemStats',
    'ContentItemRecipients',
    'SenderEmail',
    'GemUser',
    'DefaultTemplates',
    'AutomationsTemplate',
    'ToggleAutomations',
    'Mailings',
    'ServiceRequests',
    'SupportNumber'
  ],
  baseQuery: retry(gemFetchQuery({ basePath: '/api/v3' }), { maxRetries: 1 }),
  extractRehydrationInfo(action, { reducerPath }): any {
    if (action.type === HYDRATE) {
      return action.payload[reducerPath];
    }
  },
  // eslint-disable-next-line @typescript-eslint/no-unused-vars
  endpoints: builder => ({})
});
